@use '../@shared/mixins' as *;
@use '../../styles/global' as *;
@use '../host-display-block' as *;
@use '../@shared/kol-link-mixin' as *;
@use '../../styles/kol-alert-mixin' as *;

@layer kol-component {
	@include kol-link-styles('kol-link');
	@include kol-alert;
}
